import { combineReducers } from "redux";
import * as Reducer from "../reducers";

const rootReducer = combineReducers(Reducer);
export type RootReducer = ReturnType<typeof rootReducer>;
export default rootReducer;
